import Joi from "joi";

const CategorySchema = Joi.object({
  categoryName: Joi.string().trim().required().messages({
    "string.empty": "Category Name is required.",
  }),
  code: Joi.string().trim().required().messages({
    "string.empty": "Code is required.",
  }),
  isClaimRateAllowed: Joi.boolean().default(false),
  isSaleRate: Joi.boolean().default(false),
  saleRateBasedOn: Joi.object({
    option: Joi.string().trim().when('..isSaleRate', {
      is: true,
      then: Joi.string().min(1).required().messages({
        "string.empty": "Option is required when Sale Rate is enabled.",
        "any.required": "Option is required when Sale Rate is enabled.",
      }),
      otherwise: Joi.string().optional().allow("")
    }),
    percentage: Joi.number().when('..isSaleRate', {
      is: true,
      then: Joi.number().min(0).max(100).required().messages({
        "number.base": "Percentage must be a number.",
        "number.min": "Percentage cannot be negative.",
        "number.max": "Percentage cannot be more than 100.",
        "any.required": "Percentage is required when Sale Rate is enabled."
      }),
      otherwise: Joi.number().optional().allow(0)
    }),
  }).when('isSaleRate', {
    is: true,
    then: Joi.object({
      option: Joi.string().trim().min(1).required().messages({
        "string.empty": "Option is required when Sale Rate is enabled.",
        "any.required": "Option is required when Sale Rate is enabled.",
      }),
      percentage: Joi.number().min(0).max(100).required().messages({
        "number.base": "Percentage must be a number.",
        "number.min": "Percentage cannot be negative.",
        "number.max": "Percentage cannot be more than 100.",
        "any.required": "Percentage is required when Sale Rate is enabled."
      }),
    }).required(),
    otherwise: Joi.object().optional()
  }),
  limitSaleRateToMaximumToMRP: Joi.boolean().default(false),
  limitSaleRateToMinimumToPurchaseRate: Joi.boolean().default(false),
  limitSaleRateBetweenMRPAndPurchaseRate: Joi.boolean().default(false),
  applyCondition: Joi.boolean().default(false),
  active: Joi.boolean().default(true),
  allowDecimalInQty: Joi.boolean().default(false),
  isProviderMandatory: Joi.boolean().default(false),
}).unknown(true);

export default CategorySchema;
